/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, Button, Graphic } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='soundBar'>
        <Sprite name='fader'>
            <Graphic width={3840} height={2160} alpha={0.72} name='fader' color='#000000' />
        </Sprite>
        <Image position={[1188, 685]} name='bg' src='play_sound_popup_bg' />
        <Button position={[2020, 977]} hitArea={{ width: 418, x: 0, y: 0, type: 'rectangle', height: 204 }} name='yesButton'>
            <Sprite>
                <Image src='yes_no_button_normal' />
                <Image src='yes_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='yes_no_button_normal' />
                <Image src='yes_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='yes_no_button_pressed' />
                <Image src='yes_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='yes_no_button_disabled' />
                <Image src='yes_disabled_en' />
            </Sprite>
        </Button>
        <Button position={[1402, 977]} hitArea={{ width: 418, x: 0, y: 0, type: 'rectangle', height: 204 }} name='noButton'>
            <Sprite>
                <Image src='yes_no_button_normal' />
                <Image src='no_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='yes_no_button_normal' />
                <Image src='no_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='yes_no_button_pressed' />
                <Image src='no_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='yes_no_button_disabled' />
                <Image src='no_disabled_en' />
            </Sprite>
        </Button>
        <Text
            position={[1402, 718]}
            style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 79, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
            maxWidth={1036}
            name='label'
            text='PLAY SOUND?'
        />
    </Sprite>
);
